import { render } from "./EmptyAnnotation.vue?vue&type=template&id=153d72f9&scoped=true"
import script from "./EmptyAnnotation.vue?vue&type=script&lang=js"
export * from "./EmptyAnnotation.vue?vue&type=script&lang=js"

import "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=153d72f9&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153d72f9"]])

export default __exports__